import React from "react";
import { connect } from "react-redux";
import { object } from "prop-types";
import get from "lodash/get";

import FaceBookIcon from "../atoms/icons/fb";
import InstagramIcon from "../atoms/icons/instagram";
import TwitterIcon from "../atoms/icons/twitter";
import YoutubeIcon from "../atoms/icons/youtube";
import LinkedinIcon from "../atoms/icons/linkedin";
import RssIcon from "../atoms/icons/rss";
import EmailIcon from "../atoms/icons/email";

import "./social-share-icons.m.css";

const SocialShareIcons = ({ socialLinks = {}, socialUrls }) => {
  const list = [];
  list.push(
    {
      componentName: FaceBookIcon,
      url: socialLinks && socialLinks["facebook-url"],
      label: "facebook"
    },
    {
      componentName: TwitterIcon,
      url: socialLinks && socialLinks["twitter-url"],
      label: "twitter"
    },
    {
      componentName: InstagramIcon,
      url: socialLinks && socialLinks["instagram-url"],
      label: "instagram"
    },
    {
      componentName: YoutubeIcon,
      url: (socialUrls.youtubeUrl && socialUrls.youtubeUrl) || "#",
      label: "youtube"
    },
    {
      componentName: LinkedinIcon,
      url: (socialUrls.linkedinUrl && socialUrls.linkedinUrl) || "#",
      label: "linkedin"
    },
    {
      componentName: RssIcon,
      url: (socialUrls.rss && socialUrls.rss) || "#",
      label: "rss"
    },
    {
      componentName: EmailIcon,
      url: (socialUrls.email && socialUrls.email) || "#",
      label: "email"
    }
  );

  return (
    <ul styleName="icon-list" className="social-media-icon-wrapper">
      {list.map((item, index) => {
        const SocialIcons = item.componentName;
        return (
          item.url && (
            <li styleName="icon-item" key={index}>
              <a href={item.url} aria-label={`${item.label}`} target="_blank" rel="noopener noreferrer">
                <SocialIcons />
              </a>
            </li>
          )
        );
      })}
    </ul>
  );
};

SocialShareIcons.propTypes = {
  socialLinks: object,
  socialUrls: object
};

function mapStateToProps(state) {
  return {
    socialLinks: get(state, ["qt", "config", "social-links"], []),
    socialUrls: get(state, ["qt", "config", "publisher-attributes", "socialUrls"], {})
  };
}

export default connect(
  mapStateToProps,
  () => ({})
)(SocialShareIcons);
